import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dateFromLocalKey } from './dateUtils';
import { getFlexiblePrecision, isTimelineAllDayTask } from './scheduleUtils';
import { TimelineTaskModal } from './TimelineTaskModal';
import { sortPlannerTasks } from './taskListOrder';
import { PlannerTaskInfo } from './types';
import { useTimelineView } from './TimelineViewContext';

export const TimelineAllDayBar = () => {
    const { t } = useTranslation();
    const {
        activeTimelineDateKey, getTasksForDay, onDeleteTask, onEditTask,
        onToggleComplete, selectedDate, timelineScale,
    } = useTimelineView();
    const [selectedTask, setSelectedTask] = useState<PlannerTaskInfo | null>(null);
    if (timelineScale !== 'day') return null;
    const activeDay = activeTimelineDateKey ? dateFromLocalKey(activeTimelineDateKey) : selectedDate;
    const tasks = sortPlannerTasks(getTasksForDay(activeDay)
        .filter(({ task }) => getFlexiblePrecision(task) === 'day' || isTimelineAllDayTask(task)));
    if (!tasks.length) return null;
    return (
        <>
            <div className="timeline-all-day-bar">
                <div className="timeline-all-day-bar-label">
                    <span className="timeline-all-day-dot" aria-hidden="true" />
                    <span>{t('dailyPlanner.allDay')}</span>
                </div>
                <div className="timeline-all-day-items">
                    {tasks.map((taskInfo) => (
                        <button type="button" key={taskInfo.task.id}
                            className={`task-day ${taskInfo.task.completed ? 'completed' : ''}`}
                            data-timeline-task-id={taskInfo.task.id}
                            onClick={() => setSelectedTask(taskInfo)}>
                            {taskInfo.task.title}
                        </button>
                    ))}
                </div>
            </div>
            {selectedTask && (
                <TimelineTaskModal task={selectedTask.task} collectionId={selectedTask.collectionId}
                    timeLabel={t('dailyPlanner.allDay')} onClose={() => setSelectedTask(null)}
                    onDelete={onDeleteTask} onEdit={onEditTask} onToggleComplete={onToggleComplete} />
            )}
        </>
    );
};
